<template>
  <div id="app">
    <nav-bar/>
    <router-view class="page-content"/>
  </div>
</template>

<script>
import NavBar from 'components/global/NavBar'

export default {
  name: 'App',
  components: { NavBar }
}
</script>

<style lang="stylus" scoped>
  /* Local Style */
  .page-content {
    padding-top 40px
    padding-bottom 40px
  }

</style>

<style lang="stylus">
  /* Global Style */
  @import 'bootstrap/dist/css/bootstrap.css'
  @import 'bootstrap-vue/dist/bootstrap-vue.css'
  @import 'assets/highlight/github.css'

  @import "~assets/colors.styl"

  body {
    margin: 0 !important
    font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    color $blue-chambray !important
  }

  article {
    margin-bottom 40px
  }

  figcaption {
    text-align center
  }

  h1 {
    font-weight 400
    margin-bottom 25px
  }

  h2 {
    font-weight 500
    margin-bottom 10px
  }

  td.fill-black {
    background-color black
    color white
  }

  *[align='center'] {
    text-align center
  }

  *[align='right'] {
    text-align right
  }

  figcaption {
    margin-top 10px
  }

  blockquote {
    background-color: #e6f3ff;
    border-left: solid #0072c1;
    font-size: inherit;
    padding: 15px
  }

  blockquote > p {
    margin 0
  }

  pre {
    display block
    background-color: #f8f8f8;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
  }

  code {
    color: $blue-steel;
    padding: 2px 4px;
    font-size: 90%;
    background-color: #f0f4f9;
    border-radius: 4px;
  }

  td > pre {
    margin 0
    border-radius 0
  }

  pre > code {
    display: block
    padding: 0.5em;
    background-color #f8f8f8
  }

  code > span.blue {
    color $blue
  }

  .label {
    display inline
    font-size 75%
    font-weight 700
    line-height 1
    color white
    text-align center
    white-space nowrap
    vertical-align baseline
    border-radius .25em
  }
  .label-outline {
    background-color: transparent;
    border: 1px solid #ccc;
    color: #ccc;
    padding: 0.2em 0.4em 0.1em;
  }
  a.label-outline {
    color: $blue-dark;
    border: 1px solid $blue-dark;
    text-decoration none
    &:hover {
      color white
      background-color $blue-dark
    }
  }
  .center-block {
    display: block;
    margin-right: auto;
    margin-left: auto;
  }
  .img-responsive {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue